import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { debeMostrarBannerTope, puedeGestionarPlan } from '../../utils/bannerTopeDelPlan';

/**
 * Escucha el documento de la organización (como Facturación) SÓLO si quien mira puede gestionar el
 * plan, y devuelve la decisión de `utils/bannerTopeDelPlan.js`. Con cualquier fallo de lectura,
 * `{ mostrar: false }`. Vive aparte del componente para poder probarse sin `react-router-dom`, que
 * el jest de CRA no resuelve en este repo (ver `contexto/estadoDeBandeja.test.js`).
 */
export default function useTopeDelPlan(context) {
  const [orgData, setOrgData] = useState(null);
  const orgId = context?.orgId;
  const puede = puedeGestionarPlan(context);
  useEffect(() => {
    if (!orgId || !puede) return undefined;
    const unsub = onSnapshot(doc(db, 'organizations', orgId),
      (s) => setOrgData(s.exists() ? s.data() : null),
      () => setOrgData(null));
    return () => unsub();
  }, [orgId, puede]);
  return debeMostrarBannerTope(orgData, context);
}
